import React, { FC, useEffect } from 'react';
import ContractorLocationsList from './ContractorLocationsList';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getBackLinkStates } from '../../utils/HistoryUtils';
import { updateNavbarState } from '../../actions/navbar_actions';

const DEFAULT_BACK_LINK_TO = `/supplier/contractor_clients/overview`;
const DEFAULT_BACK_LINK_TEXT = 'Back to clients';

const ContractorClientLocationsPage: FC<any> = ({
	match,
	location,
	updateNavbar,
}): React.ReactElement => {
	const contractorClientId = match.params.id;

	useEffect(() => {
		const { backLinkText: text, backLinkTo: link } = getBackLinkStates(
			location,
			DEFAULT_BACK_LINK_TO
		) as any;

		updateNavbar(text || DEFAULT_BACK_LINK_TEXT, link || DEFAULT_BACK_LINK_TO);
	}, []);

	return <ContractorLocationsList contractorClientId={contractorClientId} />;
};

const mapDispatchToProps = (dispatch) => ({
	updateNavbar: (backlinkTitle, backlinkTo, navbarBackgroundColor) =>
		dispatch(updateNavbarState(backlinkTitle, backlinkTo, navbarBackgroundColor)),
});

export default withRouter<any, any>(
	connect(null, mapDispatchToProps)(ContractorClientLocationsPage)
);
